var _rect, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _path, _tspan6, _g, _tspan7, _rect2, _tspan8, _tspan9, _tspan10, _tspan11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgReactGithubData = function SvgReactGithubData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 832.41,
    height: 423.23,
    viewBox: "0 0 220.24 111.98"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.43 83.61)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220.24,
    height: 78.89,
    x: -219.43,
    y: -83.61,
    fill: "#fff",
    stroke: "#949494",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.53,
    paintOrder: "stroke markers fill",
    rx: 5.292,
    ry: 5.292
  })), /*#__PURE__*/React.createElement("text", {
    x: -210.04,
    y: -66.84,
    fill: "#0b69ff",
    strokeWidth: 0.2,
    fontFamily: "'Google Sans'",
    fontSize: 7.76,
    fontWeight: "bold",
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.25
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -210.04,
    y: -66.84
  }, "AnimatedBottomBar"))), /*#__PURE__*/React.createElement("text", {
    x: -137.227,
    y: -15.54,
    strokeWidth: 0.26,
    fontFamily: "Rockwell",
    fontSize: 6.35,
    fontWeight: "bold",
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.5
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -137.227,
    y: -15.54,
    fontFamily: "'Google Sans'",
    fontWeight: "normal"
  }, "62"))), /*#__PURE__*/React.createElement("text", {
    x: -210.019,
    y: -52.589,
    strokeWidth: 0.265,
    fontFamily: "'Google Sans'",
    fontSize: 6.35,
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.25
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: -210.019,
    y: -52.589
  }, "A customizable and easy to use BottomBar navigation view with sleek")), _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: -210.019,
    y: -44.572
  }, "animations, with support for ViewPager, ViewPager2, NavController, and")), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: -210.019,
    y: -36.555,
    dy: "0 0 0 0"
  }, "badges."))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M-144.6-20.52a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 1.06a1.12 1.12 0 10-.75 0v.44a1.12 1.12 0 001.12 1.13h.75v1.06a1.13 1.13 0 10.75 0v-1.06h.75a1.12 1.12 0 001.13-1.13v-.44a1.12 1.12 0 10-.75 0v.44a.37.37 0 01-.38.38h-2.25a.37.37 0 01-.37-.38zm1.87 3.7a.375.375 0 11-.75 0 .375.375 0 01.75 0zm1.5-4.38a.375.375 0 100-.75.375.375 0 000 .75zm-32.55-1.95a.37.37 0 01.33.21l.93 1.89 2.08.3a.37.37 0 01.2.63l-1.5 1.47.36 2.07a.37.37 0 01-.54.4l-1.86-.99-1.86.98a.37.37 0 01-.54-.39l.36-2.07-1.51-1.47a.37.37 0 01.2-.63l2.09-.3.93-1.89a.37.37 0 01.33-.2zm0 1.21l-.68 1.39a.37.37 0 01-.28.2l-1.53.22 1.1 1.08a.37.37 0 01.11.33l-.26 1.53 1.37-.72a.37.37 0 01.34 0l1.37.72-.26-1.53a.37.37 0 01.1-.33l1.11-1.07-1.53-.23a.37.37 0 01-.28-.2z"
  })), /*#__PURE__*/React.createElement("text", {
    x: -202.982,
    y: -15.461,
    strokeWidth: 0.26,
    fontFamily: "Arial",
    fontSize: 6.35,
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.25
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: -202.982,
    y: -15.461,
    fontFamily: "'Google Sans'"
  }, "Kotlin"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b69ff",
    stroke: "#fff",
    strokeWidth: 1.191,
    d: "M-155.64-15.314l-.518.926c2.137 1.193 3.215 3.547 3.547 6.366.332 2.82.07 6.181-.043 9.426s-.093 6.377.936 8.816 3.183 4.11 6.902 4.19l.023-1.06c-3.43-.075-5.048-1.405-5.949-3.542-.9-2.136-.966-5.155-.853-8.367.112-3.211.387-6.61.037-9.588-.35-2.978-1.564-5.76-4.082-7.167z",
    color: "#000",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -208.08,
    cy: -17.304,
    r: 1.839,
    fill: "#d18b00",
    paintOrder: "fill markers stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.86,
    height: 8.98,
    x: -169.48,
    y: -22.43,
    fill: "#0b69ff",
    fillOpacity: 0.25,
    stroke: "#0b69ff",
    strokeWidth: 0.81,
    paintOrder: "stroke markers fill",
    ry: 3.21
  }))), /*#__PURE__*/React.createElement("text", {
    x: -167.727,
    y: -15.66,
    strokeWidth: 0.26,
    fontFamily: "'Google Sans'",
    fontSize: 6.35,
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.5
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: -167.727,
    y: -15.66
  }, "894"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 95.686,
    height: 36.549,
    x: -146.07,
    y: -8.18,
    fill: "#1a1e24",
    stroke: "#949494",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.53,
    paintOrder: "stroke markers fill",
    rx: 5.292,
    ry: 5.292
  })), /*#__PURE__*/React.createElement("text", {
    x: -140.356,
    y: 0.404,
    strokeWidth: 0.265,
    fontFamily: "Consolas",
    fontSize: 5.95,
    letterSpacing: 0,
    wordSpacing: 0,
    style: {
      lineHeight: 1.25
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: -140.356,
    y: 0.404
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#79c0ff"
  }, "<"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#76cb67"
  }, "GitHubRepo"))), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: -140.356,
    y: 7.841
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#79c0ff"
  }, /*#__PURE__*/React.createElement("tspan", {
    fillOpacity: 0
  }, ".."), "user="), /*#__PURE__*/React.createElement("tspan", {
    fill: "#a1d6ff"
  }, "\"Droppers\""))), _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: -140.356,
    y: 15.279
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#79c0ff"
  }, /*#__PURE__*/React.createElement("tspan", {
    fillOpacity: 0
  }, ".."), "repo="), /*#__PURE__*/React.createElement("tspan", {
    fill: "#a1d6ff"
  }, "\"AnimatedBottomBar\""))), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: -140.356,
    y: 22.716
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#79c0ff"
  }, /*#__PURE__*/React.createElement("tspan", {
    fillOpacity: 0
  }, ".."), "data="), /*#__PURE__*/React.createElement("tspan", {
    fill: "#a1d6ff"
  }, "\"stars\""), /*#__PURE__*/React.createElement("tspan", {
    fill: "#79c0ff"
  }, "/>"))))));
};

;
export default SvgReactGithubData;